module.exports = __webpack_public_path__ + "static/images/pass-card-tip.c9d6ce5.png";